<template>
  <div :style="'background:' + colors.beijing" class="w-100 h-100 scrollY">
    <div v-if="biaozhi == 'ying'">
      <div
        class="fontstyle text-center padding-top-5x padding-bottom"
        :style="'color:' + colors.fontcolor"
      >
        {{ fonts.biaotiy }}
      </div>
      <div
        class="fontstyle text-center padding-bottom-3x"
        :style="'color:' + colors.ehfx"
      >
        ({{ fonts.biaoti2y }})
      </div>

      
      <div class="flex-row justify-center padding-top-2x" @click="showStatement">
        <div
          class="flex-row justify-center w-690 bs"
          :style="'background:#4A73CD'"
        >
          <div class="flex-row margin-right">
            <div
              class="fontstyle text-center padding-top-26 padding-bottom-26 padding-left-05x"
              :style="'color:' + colors.fontcolor"
            >
              statements
            </div>
          </div>
        </div>
      </div>

      <div class="flex-row justify-center padding-top-2x">
        <div class="flex-row justify-center">
          <div class="w-690 bs " :style="'background:' + colors.jieguo">
            <div
              class="flex-row justify-center padding-top-5x padding-bottom-3x"
            >
              <div class="fontstyle " :style="'color:' + colors.fontcolor">
                {{ fonts.jieguo1y }}
              </div>
              <div
                v-if="jieguo.length != 0"
                class="fontstyle padding-left-4x"
                :style="'color:' + colors.fontcolor"
              >
                {{ jieguo[0] }}
              </div>
            </div>
            <div class="flex-row justify-center padding-bottom-3x">
              <div class="fontstyle " :style="'color:' + colors.fontcolor">
                {{ fonts.jieguo2y }}
              </div>
              <div
                v-if="jieguo.length != 0"
                class="fontstyle padding-left-4x"
                :style="'color:' + colors.fontcolor"
              >
                {{ jieguo[1] }}
              </div>
            </div>
            <div class="flex-row justify-center padding-bottom-5x">
              <div class="fontstyle" :style="'color:' + colors.fontcolor">
                {{ fonts.jieguo3y }}
              </div>
              <div
                v-if="jieguo.length != 0"
                class="fontstyle padding-left-3x"
                :style="'color:' + colors.fontcolor"
              >
                {{ jieguo[2] }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-row justify-center padding-top-2x">
        <div
          class="flex-row justify-center w-690 bs"
          :style="'background:' + colors.shuru1"
        >
          <div class="flex-row margin-right">
            <input
              onfocus="this.placeholder=''"
              onblur="this.placeholder='TB'"
              type="number"
              class="fontstyle text-right padding-top-26 padding-bottom-26 inputstyle"
              :style="
                'color:' + colors.fontcolor + ';background:' + colors.shuru1
              "
              v-model="shuru1"
              placeholder="TB"
            />
            <div
              class="fontstyle text-center padding-top-26 padding-bottom-26 padding-left-05x"
              :style="'color:' + colors.fontcolor"
            >
              (umol/L)
            </div>
          </div>
        </div>
      </div>
      <div class="flex-row justify-center padding-top-2x">
        <div
          class="flex-row justify-center w-690 bs "
          :style="'background:' + colors.shuru2"
        >
          <div class="flex-row margin-right">
            <input
              onfocus="this.placeholder=''"
              onblur="this.placeholder='Na'"
              type="number"
              class="fontstyle text-right padding-top-26 padding-bottom-26 inputstyle"
              :style="
                'color:' + colors.fontcolor + ';background:' + colors.shuru2
              "
              v-model="shuru2"
              placeholder="Na"
            />
            <div
              class="fontstyle text-center padding-top-26 padding-bottom-26 padding-left-05x"
              :style="'color:' + colors.fontcolor"
            >
              (mmol/L)
            </div>
          </div>
        </div>
      </div>

      <div class="flex-row justify-center padding-top-2x">
        <div
          class="flex-row justify-center w-690 bs "
          :style="'background:' + colors.shuru3"
        >
          <div class="flex-row margin-right">
            <input
              onfocus="this.placeholder=''"
              onblur="this.placeholder='PLT'"
              type="number"
              class="fontstyle text-right padding-top-26 padding-bottom-26 inputstyle"
              :style="
                'color:' + colors.fontcolor + ';background:' + colors.shuru3
              "
              v-model="shuru3"
              placeholder="PLT"
            />
            <div
              class="fontstyle text-center padding-top-26 padding-bottom-26 padding-left-05x"
              :style="'color:' + colors.fontcolor"
            >
              (*10<sup data-v-154dfe09="">9</sup>/L)
            </div>
          </div>
        </div>
      </div>

      <div class="flex-row justify-center padding-top-2x">
        <div
          class="flex-row justify-center w-690 bs "
          :style="'background:' + colors.shuru5"
        >
          <div class="flex-row margin-right">
            <input
              onfocus="this.placeholder=''"
              onblur="this.placeholder='INR'"
              type="number"
              class="fontstyle text-right padding-top-26 padding-bottom-26 inputstyle"
              :style="
                'color:' + colors.fontcolor + ';background:' + colors.shuru5
              "
              v-model="shuru5"
              placeholder="INR"
            />
            <div
              class="fontstyle text-center padding-top-26 padding-bottom-26 padding-left-05x"
              :style="'color:' + colors.fontcolor"
            ></div>
          </div>
        </div>
      </div>
      <div class="flex-row justify-center padding-top-2x">
        <div
          class="flex-row justify-center w-690 bs "
          :style="'background:' + colors.shuru6"
        >
          <div class="flex-row ">
            <input
              onfocus="this.placeholder=''"
              onblur="this.placeholder='2D-SWE'"
              type="number"
              class="fontstyle text-right padding-top-26 padding-bottom-26 inputstyle2"
              :style="
                'color:' + colors.fontcolor + ';background:' + colors.shuru6
              "
              v-model="shuru6"
              placeholder="2D-SWE"
            />
            <div
              class="fontstyle text-center padding-top-26 padding-bottom-26 padding-left-05x"
              :style="'color:' + colors.fontcolor"
            >
              (kPa)
            </div>
          </div>
        </div>
      </div>

      <div class="flex-row justify-between padding-top-7x padding-bottom-118">
        <div class="padding-left-3x padding-top-2x" @click="clear">
          <div
            class="fontstyle1 padding-top-1x padding-bottom-1x padding-left-3x padding-right-3x"
            :style="'color:' + colors.clearf + ';background:' + colors.clear"
          >
            {{ fonts.cleary }}
          </div>
        </div>
            <img
              class="icon-11x"
              :src="uploadpath + 'resource/' + Res.yingwen"
              alt=""
              @click="zhuanhuan"
            />
      </div>

      <div
        class="flex-row justify-center  padding-bottom-3x w-100"
        style="position:fixed; bottom:0"
      >
        <div
          @click="yuce"
          class="w-690 bs "
          :style="'background:' + colors.anniu"
        >
          <div
            class="fontstyle text-center padding-top-26 padding-bottom-26"
            :style="'color:' + colors.fontcolor"
          >
            {{ fonts.anniuy }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="biaozhi == 'han'">
      <div
        class="fontstyle text-center padding-top-5x padding-bottom"
        :style="'color:' + colors.fontcolor"
      >
        {{ fonts.biaotih }}
      </div>
      <div
        class="fontstyle text-center padding-bottom-3x"
        :style="'color:' + colors.ehfx"
      >
        ({{ fonts.biaoti2h }})
      </div>


      <div class="flex-row justify-center padding-top-2x" @click="showStatement">
        <div
          class="flex-row justify-center w-690 bs"
          :style="'background:#4A73CD'"
        >
          <div class="flex-row margin-right">
            <div
              class="fontstyle text-center padding-top-26 padding-bottom-26 padding-left-05x"
              :style="'color:' + colors.fontcolor"
            >
              使用声明
            </div>
          </div>
        </div>
      </div>

      <div class="flex-row justify-center padding-top-2x">
        <div class="w-690 bs " :style="'background:' + colors.jieguo">
          <div class="flex-row justify-center padding-top-5x padding-bottom-3x">
            <div class="fontstyle " :style="'color:' + colors.fontcolor">
              {{ fonts.jieguo1h }}
            </div>
            <div
              v-if="jieguo.length != 0"
              class="fontstyle padding-left-4x"
              :style="'color:' + colors.fontcolor"
            >
              {{ jieguo[0] }}
            </div>
          </div>
          <div class="flex-row justify-center padding-bottom-3x">
            <div class="fontstyle " :style="'color:' + colors.fontcolor">
              {{ fonts.jieguo2h }}
            </div>
            <div
              v-if="jieguo.length != 0"
              class="fontstyle padding-left-4x"
              :style="'color:' + colors.fontcolor"
            >
              {{ jieguo[1] }}
            </div>
          </div>
          <div class="flex-row justify-center padding-bottom-5x">
            <div class="fontstyle" :style="'color:' + colors.fontcolor">
              {{ fonts.jieguo3h }}
            </div>
            <div
              v-if="jieguo.length != 0"
              class="fontstyle padding-left-4x"
              :style="'color:' + colors.fontcolor"
            >
              {{ jieguo[2] }}
            </div>
          </div>
        </div>
      </div>

      <div class="flex-row justify-center padding-top-2x">
        <div
          class="flex-row justify-center w-690 bs"
          :style="'background:' + colors.shuru1"
        >
          <div class="flex-row margin-right">
            <input
              onfocus="this.placeholder=''"
              onblur="this.placeholder='TB'"
              type="number"
              class="fontstyle text-right padding-top-26 padding-bottom-26 inputstyle"
              :style="
                'color:' + colors.fontcolor + ';background:' + colors.shuru1
              "
              v-model="shuru1"
              placeholder="TB"
            />
            <div
              class="fontstyle text-center padding-top-26 padding-bottom-26 padding-left-05x"
              :style="'color:' + colors.fontcolor"
            >
              (umol/L)
            </div>
          </div>
        </div>
      </div>
      <div class="flex-row justify-center padding-top-2x">
        <div
          class="flex-row justify-center w-690 bs "
          :style="'background:' + colors.shuru2"
        >
          <div class="flex-row margin-right">
            <input
              onfocus="this.placeholder=''"
              onblur="this.placeholder='Na'"
              type="number"
              class="fontstyle text-right padding-top-26 padding-bottom-26 inputstyle"
              :style="
                'color:' + colors.fontcolor + ';background:' + colors.shuru2
              "
              v-model="shuru2"
              placeholder="Na"
            />
            <div
              class="fontstyle text-center padding-top-26 padding-bottom-26 padding-left-05x"
              :style="'color:' + colors.fontcolor"
            >
              (mmol/L)
            </div>
          </div>
        </div>
      </div>

      <div class="flex-row justify-center padding-top-2x">
        <div
          class="flex-row justify-center w-690 bs "
          :style="'background:' + colors.shuru3"
        >
          <div class="flex-row margin-right">
            <input
              onfocus="this.placeholder=''"
              onblur="this.placeholder='PLT'"
              type="number"
              class="fontstyle text-right padding-top-26 padding-bottom-26 inputstyle"
              :style="
                'color:' + colors.fontcolor + ';background:' + colors.shuru3
              "
              v-model="shuru3"
              placeholder="PLT"
            />
            <div
              class="fontstyle text-center padding-top-26 padding-bottom-26 padding-left-05x"
              :style="'color:' + colors.fontcolor"
            >
              (*10<sup data-v-154dfe09="">9</sup>/L)
            </div>
          </div>
        </div>
      </div>

      <div class="flex-row justify-center padding-top-2x">
        <div
          class="flex-row justify-center w-690 bs "
          :style="'background:' + colors.shuru5"
        >
          <div class="flex-row margin-right">
            <input
              onfocus="this.placeholder=''"
              onblur="this.placeholder='INR'"
              type="number"
              class="fontstyle text-right padding-top-26 padding-bottom-26 inputstyle"
              :style="
                'color:' + colors.fontcolor + ';background:' + colors.shuru5
              "
              v-model="shuru5"
              placeholder="INR"
            />
            <div
              class="fontstyle text-center padding-top-26 padding-bottom-26 padding-left-05x"
              :style="'color:' + colors.fontcolor"
            ></div>
          </div>
        </div>
      </div>
      <div class="flex-row justify-center padding-top-2x">
        <div
          class="flex-row justify-center w-690 bs "
          :style="'background:' + colors.shuru6"
        >
          <div class="flex-row ">
            <input
              onfocus="this.placeholder=''"
              onblur="this.placeholder='2D-SWE'"
              type="number"
              class="fontstyle text-right padding-top-26 padding-bottom-26 inputstyle2"
              :style="
                'color:' + colors.fontcolor + ';background:' + colors.shuru6
              "
              v-model="shuru6"
              placeholder="2D-SWE"
            />
            <div
              class="fontstyle text-center padding-top-26 padding-bottom-26 padding-left-05x"
              :style="'color:' + colors.fontcolor"
            >
              (kPa)
            </div>
          </div>
        </div>
      </div>

      <div class="flex-row justify-between padding-top-7x padding-bottom-118">
        <div class="padding-left-3x padding-top-2x" @click="clear">
          <div
            class="fontstyle1 padding-top-1x padding-bottom-1x padding-left-3x padding-right-3x"
            :style="'color:' + colors.clearf + ';background:' + colors.clear"
          >
            {{ fonts.clearh }}
          </div>
        </div>
        
            <img
              class="icon-11x"
              :src="uploadpath + 'resource/' + Res.zhongwen"
              alt=""
              @click="zhuanhuan"
            />
      </div>

      <div
        class="flex-row justify-center  padding-bottom-3x w-100"
        style="position:fixed; bottom:0"
      >
        <div
          @click="yuce"
          class="w-690 bs "
          :style="'background:' + colors.anniu"
        >
          <div
            class="fontstyle text-center padding-top-26 padding-bottom-26"
            :style="'color:' + colors.fontcolor"
          >
            {{ fonts.anniuh }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Config from "../Config";
import { PageHelper } from "../PageHelper";
import { HttpHelper } from "../HttpHelper";
import { Utils } from "../Utils";
import { Toast } from "vant";

export default {
  data() {
    return {
      Res: {},
      colors: "",
      fonts: "",
      biaozhi: "ying",
      shuru1: "",
      shuru2: "",
      shuru3: "",
      shuru4: "",
      shuru5: "",
      shuru6: "",
      jieguo: []
      // Inst: {},
      // Member: null,
      // bannerlist: [],
      // productlist: [],
      // problemlist: [],
      // attrlist: [],
      // list: [],
      // show: false,
      // right: "A",
      // type: [],
      // shoplist: [],
      // image: "",
      // biaoti: "",
      // token: "",
      // seqway: 0,
      // seqtype: "A",
      // seqimage: "",
      // seqimage1: "",
      // first:0
    };
  },

  created() {
    PageHelper.Init(this);
    HttpHelper.Post("calculate/colordetail", {}).then(ret => {
      this.colors = ret;
    });
    HttpHelper.Post("calculate/fontdetail", {}).then(ret => {
      this.fonts = ret;
    });
    // this.token = window.localStorage.getItem("token");
    // //首页不缓存
    // this.$route.meta.keepAlive=true;
    // console.log(this.token);
  },
  methods: {
    zhuanhuan() {
      if (this.biaozhi == "ying") {
        this.biaozhi = "han";
      } else {
        this.biaozhi = "ying";
      }
      console.log(this.biaozhi);
    },
    showStatement(){
      this.$router.push({
        name: 'statement',
        params: { lang: this.biaozhi }  // 这里替换成你需要的语言
      });
    },
    yuce() {
      console.log(this.shuru1);
      HttpHelper.Post("calculate/shangchuan", {
        TB: this.shuru1,
        NA: this.shuru2,
        PLT: this.shuru3,
        INR: this.shuru5,
        SWE: this.shuru6
      }).then(ret => {
        this.jieguo = ret;
        console.log(ret);
      });
    },
    clear() {
      (this.shuru1 = ""),
        (this.shuru2 = ""),
        (this.shuru3 = ""),
        (this.shuru4 = ""),
        (this.shuru5 = ""),
        (this.shuru6 = ""),
        (this.jieguo = []);
    }
    // dianji(id, seqtype) {
    //   console.log(seqtype);
    //   this.seqway = id;
    //   this.seqtype = seqtype;
    //   HttpHelper.Post("shop/shoplist", { type: id, way: seqtype }).then(
    //     (ret) => {
    //       console.log(ret);
    //       this.shoplist = ret;
    //     }
    //   );
    //   this.biaoti = id;
    //   this.imglist(seqtype);
    // },
    // imglist(seqtype) {
    //   if (seqtype == "A") {
    //     this.seqimage = this.uploadpath + "resource/" + this.Res.xz_hot;
    //     this.seqimage1 = this.uploadpath + "resource/" + this.Res.good;
    //   } else {
    //     this.seqimage = this.uploadpath + "resource/" + this.Res.hot;
    //     this.seqimage1 = this.uploadpath + "resource/" + this.Res.xz_good;
    //   }
    // },
    // detail(id) {
    //   // this.$route.meta.keepAlive=true;
    //   this.routeto("/detail/" + id+"/"+1);
    // },
    // pandaun() {
    //   this.Token();
    //   this.$route.meta.keepAlive=false;
    //   if (this.token == "null" || this.token == "" || this.token == null) {
    //     Toast("请先登录！");
    //     this.routeto("/login");
    //   } else {
    //     this.routeto("/my");
    //   }
    // },
    // pandaun1() {
    //   this.Token();
    //   if (this.token == "null" || this.token == "" || this.token == null) {
    //     Toast("请先登录！");
    //     this.routeto("/login");
    //   } else {
    //     this.routeto("/type");
    //   }
    // },
    // panduan() {
    //   this.$route.meta.keepAlive=false;
    //   if (this.token == "null" || this.token == "" || this.token == null) {
    //     Toast("请先登录！");
    //     this.routeto("/login");
    //   } else {
    //     this.routeto("/suggest");
    //   }
    // },
    // Token(){
    //   //首页会缓存
    //   this.$route.meta.keepAlive=false;
    //   this.token = window.localStorage.getItem("token");
    // },
    // gongxin(){
    //   window.location.href = this.Inst.url
    // }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue